import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 0a14 14 0 1 0 0 28 14 14 0 0 0 0-28ZM7.098 22.792C7.7 21.532 11.368 20.3 14 20.3c2.632 0 6.3 1.232 6.902 2.492A11.05 11.05 0 0 1 14 25.2a11.05 11.05 0 0 1-6.902-2.408Zm15.806-2.03C20.902 18.326 16.044 17.5 14 17.5c-2.044 0-6.902.826-8.904 3.262A11.1 11.1 0 0 1 2.8 14C2.8 7.826 7.826 2.8 14 2.8c6.174 0 11.2 5.026 11.2 11.2a11.1 11.1 0 0 1-2.296 6.762ZM14 5.6a4.888 4.888 0 0 0-4.9 4.9c0 2.716 2.184 4.9 4.9 4.9s4.9-2.184 4.9-4.9-2.184-4.9-4.9-4.9Zm0 7a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }